(function() {
  'use strict';

  // === Tracking recently viewed (na każdej stronie z PDP) ===
  function trackRecentlyViewed() {
    const match = window.location.pathname.match(/^\/products\/([^/?#]+)/);
    if (!match) return;
    const handle = match[1];

    let viewed = [];
    try {
      const stored = localStorage.getItem('ms_recently_viewed');
      if (stored) viewed = JSON.parse(stored);
    } catch(e) { viewed = []; }

    viewed = viewed.filter(h => h !== handle);
    viewed.unshift(handle);
    viewed = viewed.slice(0, 12);

    try {
      localStorage.setItem('ms_recently_viewed', JSON.stringify(viewed));
    } catch(e) {}
  }

  // === Hydracja sekcji "Wybrane dla Ciebie" ===
  async function hydrateRecommended() {
    const grid = document.getElementById('cro-products-grid');
    const titleEl = document.getElementById('cro-products-title');
    if (!grid || !titleEl) return;

    let mode = 'recommended';
    let products = [];

    // Recently viewed (Mode A)
    let recentHandles = [];
    try {
      const stored = localStorage.getItem('ms_recently_viewed');
      if (stored) recentHandles = JSON.parse(stored).slice(0, 4);
    } catch(e) {}

    if (recentHandles.length >= 2) {
      const fetched = await Promise.all(recentHandles.map(h =>
        fetch('/products/' + h + '.js').then(r => r.ok ? r.json() : null).catch(() => null)
      ));
      const valid = fetched.filter(Boolean).slice(0, 4);
      if (valid.length >= 2) {
        mode = 'recently';
        products = valid.map(p => ({
          handle: p.handle,
          title: p.title,
          img: p.featured_image,
          price: formatPriceCents(p.price),
          compareAt: p.compare_at_price > p.price ? formatPriceCents(p.compare_at_price) : null
        }));
      }
    }

    // Random sale (Mode B)
    if (mode !== 'recently') {
      try {
        const r = await fetch('/products.json?limit=50');
        const data = await r.json();
        const onSale = data.products.filter(p => {
          const v = p.variants[0];
          return v && parseFloat(v.compare_at_price) > parseFloat(v.price);
        });
        const shuffled = onSale.sort(() => Math.random() - 0.5).slice(0, 4);
        if (shuffled.length >= 2) {
          products = shuffled.map(p => ({
            handle: p.handle,
            title: p.title,
            img: p.images[0] && p.images[0].src,
            price: formatPriceString(p.variants[0].price),
            compareAt: formatPriceString(p.variants[0].compare_at_price)
          }));
        }
      } catch(e) { return; }
    }

    if (products.length < 2) return;

    titleEl.textContent = mode === 'recently' ? 'Ostatnio oglądane' : 'Wybrane dla Ciebie';

    grid.innerHTML = products.map(p =>
      '<a href="/products/' + p.handle + '" class="cro-product">' +
        '<div class="cro-product-img-wrap">' +
          '<img class="cro-product-img" src="' + p.img + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' +
        '</div>' +
        '<p class="cro-product-title">' + escapeHtml(p.title) + '</p>' +
        '<div class="cro-product-prices">' +
          '<span class="cro-product-price">' + p.price + '</span>' +
          (p.compareAt ? '<span class="cro-product-compare">' + p.compareAt + '</span>' : '') +
        '</div>' +
      '</a>'
    ).join('');
  }

  // === Tag chip → wpisz query do search inputu ===
  function bindTagChips() {
    document.querySelectorAll('#ms-search-cro .cro-tag').forEach(btn => {
      btn.addEventListener('click', () => {
        const modal = document.querySelector('.ms-search-modal');
        const input = modal && modal.querySelector('input[type=search], input[name=q]');
        if (input) {
          input.value = btn.dataset.query;
          input.focus();
          input.dispatchEvent(new Event('input', { bubbles: true }));
        }
      });
    });
  }

  // === Helpers ===
  function formatPriceCents(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' zł';
  }
  function formatPriceString(str) {
    return parseFloat(str).toFixed(2).replace('.', ',') + ' zł';
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  }

  // === Init ===
  function init() {
    trackRecentlyViewed();

    const modal = document.querySelector('.ms-search-modal');
    if (!modal) return;

    let hydrated = false;
    const hydrate = () => {
      if (hydrated) return;
      hydrated = true;
      hydrateRecommended();
      bindTagChips();
    };

    // Lazy hydrate gdy modal się otwiera
    const observer = new MutationObserver(() => {
      if (modal.open) hydrate();
    });
    observer.observe(modal, { attributes: true, attributeFilter: ['open'] });

    if (modal.open) hydrate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
